// Types
import type { RouteLocationNormalizedLoaded, Router } from 'vue-router';
import type { TListingsStore } from '~/misc/listings/store/types';
import type { TListingFilterLocation } from '~/misc/listings/types';

export class OpportunitiesStoreToQueryResolver {
  constructor(
    protected store: TListingsStore,
    protected router: Router,
    protected route: RouteLocationNormalizedLoaded
  ) {}

  public async process() {
    const route: RouteLocationNormalizedLoaded = await this.applyStatus(this.route)
      .then((value: RouteLocationNormalizedLoaded) => this.applyAgentId(value))
      .then((value: RouteLocationNormalizedLoaded) => this.applyLocation(value));

    this.handleRoute(route);
  }

  protected async applyStatus(route: RouteLocationNormalizedLoaded) {
    return await this.router.resolve({
      ...route,
      query: { ...route.query, status: this.store.status ?? undefined },
    });
  }

  protected async applyAgentId(route: RouteLocationNormalizedLoaded) {
    return await this.router.resolve({
      ...route,
      query: {
        ...route.query,
        agents: Array.isArray(this.store.filters.agents)
          ? [...this.store.filters.agents].join(',')
          : undefined,
      },
    });
  }

  protected async applyLocation(route: RouteLocationNormalizedLoaded) {
    const location: TListingFilterLocation | undefined = this.store.filters.location;

    return await this.router.resolve({
      ...route,
      query: {
        ...route.query,
        location: location ? [location.type, location.value].join(',') : undefined,
      },
    });
  }

  protected handleRoute(route: RouteLocationNormalizedLoaded) {
    this.router.replace(route);
  }
}
